module.exports = __webpack_public_path__ + "img/0Q3B2213_Black.a33808e5.jpg";